import { createLoader, parseAsString, parseAsStringLiteral } from 'nuqs/server';

const periodSlugs = [
  'custom',
  'lastweek',
  'last4weeks',
  'last30days',
  'lastmonth',
  'lastquarter',
  'lasthalfyear',
  'lastyear',
  'currentquarter',
  'all',
] as const;

const compareSlugs = ['previous', 'year-1', 'year-2', 'year-3', 'year-4', 'year-5', 'undefined'] as const;

type PeriodSlug = (typeof periodSlugs)[number];
type CompareSlug = (typeof compareSlugs)[number];

export type Defaults = {
  periodSlug: PeriodSlug;
  compareSlug: CompareSlug;
};

const urlKeys = {
  compareSlug: 'compare-period',
  periodSlug: 'periodSlug',
};

const keyMaps = (defaults: Defaults) => ({
  compareSlug: parseAsStringLiteral<CompareSlug>(compareSlugs).withDefault(defaults.compareSlug),
  periodSlug: parseAsStringLiteral<PeriodSlug>(periodSlugs).withDefault(defaults.periodSlug),
  start: parseAsString.withDefault(''),
  end: parseAsString.withDefault(''),
});

const periodLoader = (defaults: Defaults) => createLoader(keyMaps(defaults), { urlKeys });

export { type CompareSlug, compareSlugs, keyMaps, type PeriodSlug, periodLoader, periodSlugs, urlKeys };
